/** 
 * @module Application container
 * 
 */

import { connect } from 'react-redux'
import {changeLabel, fetchActivities,fetchFamousRaces,login,logout} from '../actions'
import Editor from '../components/Editor'

const mapStateToProps = (state) => {
    return state;
}

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeLabel: (key,value) => {
            dispatch(changeLabel(key,value));
        },
        onFetchActivities:(token,options)=>{
            dispatch(fetchActivities(token,options))
        },
        onFetchFamousRaces:(options)=>{
            dispatch(fetchFamousRaces(options))
        },
        onLogin:(user)=>{
            dispatch(login(user))
        },
        onLogout:()=>{
            dispatch(logout())
        }
    }
}

const RxEditor = connect(
    mapStateToProps,
    mapDispatchToProps
)(Editor)

export default RxEditor


// WEBPACK FOOTER //
// ./src/containers/RxEditor.js